function isExist(selector){
    return document.querySelector(selector)?true:false;
}